<!-- @format -->
<template>
    <div class="contact-subscribe-widget">
        <div class="widget-contents-container">
            <div class="widget-header">
                <h3>Subscribe</h3>
                <div class="svg-container widget-close-button" @click="closeWidget">
                    <widget-close-svg />
                </div>
            </div>
            <div class="content-wrapper">
                <loading-svg v-if="saving || loading" />
                <div v-else>
                    <app-border-section :topText="`${contact.name}'s Email Preferences`">
                        <app-input-radio
                            v-model="selectedOption"
                            :options="subscribeOptions"
                            horizontal
                            centered
                        />
                    </app-border-section>
                </div>
            </div>

            <div class="widget-footer">
                <div class="cancel-container">
                    <app-button class="transparent-btn" @click="closeWidget"> Cancel </app-button>
                </div>
                <div class="action-container">
                    <app-button :disabled="saving || loading" @click="save()"> Save </app-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const AppBorderSection = () => import('@/components/common/app-border-section');
const AppButton = () => import('@/components/common/app-button');
const AppInputRadio = () => import('@/components/common/app-input-radio');
const LoadingSvg = () => import('@/components/svg/loading-screen-svg');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg');

import EventBus from '@/scripts/event-bus.js';
import log, { LogLevel } from '@/scripts/logger';

export default {
    name: 'contact-subscribe-widget',

    components: {
        'app-border-section': AppBorderSection,
        'app-button': AppButton,
        'app-input-radio': AppInputRadio,
        'loading-svg': LoadingSvg,
        'widget-close-svg': WidgetCloseSvg,
    },

    props: {
        widget: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            loading: true,
            saving: false,
            selectedOption: null,
            contact: {
                id: this.widget.contactId,
                name: null,
            },
            subscribeOptions: [
                {
                    name: 'Subscribed',
                    value: 'subscribed',
                    imageUrl: require('../../assets/images/SVG/success-confirmation.svg'),
                    description:
                        'This person has opted in and authorized to receive emails from your company.',
                },
                {
                    name: 'Unsubscribed',
                    value: 'unsubscribed',
                    imageUrl: require('../../assets/images/SVG/error-confirmation.svg'),
                    description:
                        'This person will no longer receive emails from campaigns or journeys.',
                },
            ],
        };
    },

    created() {
        this.getContact();
    },

    methods: {
        save() {
            this.saving = true;

            var changes = [
                {
                    name: 'IsSubscribed',
                    value: this.selectedOption.value === 'subscribed',
                },
            ];

            this.$api
                .patch(`/api/Contacts/${this.contact.id}`, changes)
                .then(() => {
                    this.$helpers.showSuccessNotification(
                        `Successfully updated ${this.contact.name}'s subscription settings.`
                    );
                    this.closeWidget();
                    EventBus.$emit('contact:update');
                })
                .catch((error) => {
                    this.$helpers.showFailNotification(
                        `An error occurred while updating ${this.contact.name}'s subscription settings.`,
                        { level: LogLevel.DEBUG }
                    );
                    log.error(
                        'An error occurred while updating contact subscription settings.',
                        error
                    );
                })
                .finally(() => {
                    this.saving = false;
                });
        },

        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        getContact() {
            return new Promise((resolve, reject) => {
                this.$api
                    .get(`/service/Contacts?$filter=Id eq ${this.contact.id}`)
                    .then((response) => {
                        var contactsResponse = response.data.value[0];

                        this.contact = {
                            id: contactsResponse.Id,
                            name: this.$helpers.getName(
                                contactsResponse.FirstName,
                                contactsResponse.LastName
                            ),
                        };

                        if (contactsResponse.IsSubscribed === false) {
                            this.selectedOption = this.subscribeOptions[1];
                        } else {
                            this.selectedOption = this.subscribeOptions[0];
                        }

                        resolve();
                    })
                    .catch((error) => {
                        const message = 'An error occurred while fetching the contact.';
                        log.error(message, error);
                        reject(message);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            });
        },
    },
};
</script>

<style>
.contact-subscribe-widget .content-wrapper .app-border-section .content {
    padding: 0px 25px;
}

.contact-subscribe-widget .content-wrapper .app-border-section .top-text,
.contact-subscribe-widget .app-input-radio .app-border-section .option .radio-option-label {
    font-weight: 600;
}

.contact-subscribe-widget .content-wrapper .app-border-section .option {
    width: 250px;
}

.contact-subscribe-widget .content-wrapper .app-border-section .option:first-of-type {
    margin-right: 25px;
}

.contact-subscribe-widget .content-wrapper .app-border-section .option-image {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 250px;
    height: 151px;
    background-color: #fff;
    border: 2px solid #e9e9ef;
    border-radius: 10px;
    padding: 10px 60px;
}

.contact-subscribe-widget .content-wrapper .app-border-section .option-description {
    font: normal normal normal 14px/25px Roboto;
}

.contact-subscribe-widget .cancel-container .btn.transparent-btn {
    background: transparent;
    color: #877d88;
}

.contact-subscribe-widget .cancel-container .btn.transparent-btn:hover {
    background: #e1e0e5;
}
</style>
